import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const RESERVE_REPORT_FIXED_COLUMNS = 5;

export const RESERVE_REPORT_COLUMN_FIELDS = [
  null,
  "createdAt",
  "order_no",
  "SKU",
  "stock_id",
  "metal_name",
  "stone_name",
  "size_name",
  "Qty",
  "price",
  "formated_amount",
  "formated_payment",
  "formated_outstanding",
  "location_name",
  "customer_name",
  "sales_person",
];

const NUMERIC_FIELDS = new Set([
  "Qty",
  "price",
  "formated_amount",
  "formated_payment",
  "formated_outstanding",
  "amount",
  "payment",
  "outstanding",
]);

const DATE_FIELDS = new Set(["createdAt"]);

const parseNumericValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  if (Number.isFinite(num)) return num;
  const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
};

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (DATE_FIELDS.has(field)) return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) return parseNumericValue(value);
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortReserveReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = RESERVE_REPORT_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
